import * as React from 'react';
import * as _ from 'lodash-es';
import cx from 'classnames';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import OutlinedInput from '@mui/material/OutlinedInput';
import CloseIcon from '@mui/icons-material/Close';
import { KeyboardArrowDown } from '@mui/icons-material';
import { FormHelperText } from '@mui/material';

const styles = require('./styles.pcss');

type Props = {
  value: Array<any>;
  label?: string;
  selections: Array<any>;
  onChange: any;
  error?: any;
  disabled?: any;
};

class MultiSelect extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  onOpen = (e: any) => {
    this.setState({
      open: true,
    });
  };

  onClose = (e: any) => {
    this.setState({
      open: false,
    });
  };

  onChange = (event: any) => {
    this.props.onChange(event.target.value);
  };

  handleDelete = (key: any) => () => {
    let value = _.cloneDeep(this.props.value);

    _.remove(value, (v) => String(v) === String(key));

    this.props.onChange(value);
  };

  render() {
    let shrink = this.props.value.length > 0 ? true : false;
    return (
      <FormControl
        error={!!this.props.error}
        className={styles.formControl}
        margin="normal"
        variant="outlined"
        disabled={this.props.disabled}
      >
        <InputLabel
          htmlFor="select-multiple"
          shrink={shrink}
        >
          {this.props.label}
        </InputLabel>
        <Select
          className={this.state.open ? styles.selectedM : styles.selectM}
          multiple
          value={this.props.value}
          onChange={this.onChange}
          onOpen={this.onOpen}
          onClose={this.onClose}
          open={this.state.open}
          IconComponent={() => (
            <KeyboardArrowDown className={styles.iconStyle} />
          )}
          input={
            <OutlinedInput
              error={!!this.props.error}
              inputProps={{ className: styles.selectInput }}
              fullWidth
              name="select-multiple"
            />
          }
          renderValue={(selected: Array<any>) => (
            <div className={styles.chips}>
              {selected.map((item) => {
                const selection = _.find(
                  this.props.selections,
                  (s) => String(s.key) === String(item),
                );

                if (!selection) {
                  return null;
                }

                return (
                  <Chip
                    key={selection.key}
                    label={selection.value}
                    className={styles.chip}
                    onDelete={this.handleDelete(selection.key)}
                    deleteIcon={<CloseIcon className={styles.deleteChipIcon} />}
                  />
                );
              })}
            </div>
          )}
          MenuProps={{
            style: { marginTop: 4, boxShadow: 'none' },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          }}
        >
          {this.props.selections.map((selection) => {
            let className = styles.menuItem;
            if (this.props.value.some((v: any) => String(v) === String(selection.key))) {
              className = cx(styles.menuItem, styles.menuItemSelected);
            }

            return (
              <MenuItem
                key={selection.key}
                value={selection.key}
                className={className}
              >
                {selection.value}
              </MenuItem>
            );
          })}
        </Select>
        {this.props.error && (
          <FormHelperText error={true}>{this.props.error}</FormHelperText>
        )}
      </FormControl>
    );
  }
}

export default MultiSelect;
